/**
 * Home-page divisions (mirrors backend `src/config/homeSections.js`).
 *
 * Today a division is one tile in the home header. Visibility is stored per user
 * as `permissions.hiddenHomeSections` — the HIDDEN list, so a user with nothing
 * configured sees every division and a division added later shows up for
 * everyone instead of staying silently hidden.
 *
 * Hiding a division is presentation only: it never grants or removes access to
 * the underlying module, which `requireCard` still decides on the server.
 *
 * The greeting itself has no id here — it is always rendered.
 */

export const HOME_SECTION_TODAY_TASKS = 'today-tasks';
export const HOME_SECTION_DOC_LOG = 'document-log-book';

export const HOME_SECTIONS = [
    {
        id: HOME_SECTION_TODAY_TASKS,
        label: "Today's Tasks tile",
        description: 'How many of the user\'s tasks are due today'
    },
    {
        id: HOME_SECTION_DOC_LOG,
        label: 'Document Log Book tile',
        description: 'How many log-book documents are waiting for the user'
    }
];
